// Service taxonomy — single source of truth for Services section + Consultation modal.

export const CATEGORIES = [
  {
    id: "clarify",
    label: "Clarify",
    purpose:
      "Understand who you are, what you are building, where your energy is leaking, and what direction is aligned.",
    services: [
      "Brand Identity Discovery",
      "Offer Clarity",
      "Personal Brand Positioning",
      "Personal Action Plan Interpretation",
    ],
    cta: "Explore This Path",
  },
  {
    id: "build",
    label: "Build",
    purpose:
      "Turn clarity into websites, landing pages, funnels, and visible digital presence.",
    services: [
      "Website Buildout",
      "Landing Page Creation",
      "Service Funnel",
      "AI-Assisted Website Build",
    ],
    cta: "Build This Direction",
  },
  {
    id: "express",
    label: "Express",
    purpose:
      "Communicate your identity through content, visual language, and social presence.",
    services: [
      "Social Media Brand Direction",
      "UGC Content Strategy",
      "Visual Identity Direction",
      "Content System Design",
    ],
    cta: "Express This Voice",
  },
  {
    id: "scale",
    label: "Scale",
    purpose:
      "Systems, strategy, and ecosystem structure that support long-term growth.",
    services: [
      "Creative System Design",
      "Digital Presence Consulting",
      "Ecosystem Strategy",
      "Automation-Ready Brand Infrastructure",
    ],
    cta: "Scale This Movement",
  },
];

export const PRIMARY_CATEGORY_OPTIONS = [
  { value: "Clarify", label: "Clarify" },
  { value: "Build", label: "Build" },
  { value: "Express", label: "Express" },
  { value: "Scale", label: "Scale" },
  { value: "Not sure yet", label: "Not sure yet" },
];

export const SPECIFIC_INTERESTS = [
  "Brand Identity Discovery",
  "Offer Clarity",
  "Personal Brand Positioning",
  "Personal Action Plan Interpretation",
  "Website Buildout",
  "Landing Page Creation",
  "Service Funnel",
  "AI-Assisted Website Build",
  "Social Media Brand Direction",
  "UGC Content Strategy",
  "Visual Identity Direction",
  "Content System Design",
  "Creative System Design",
  "Digital Presence Consulting",
  "Ecosystem Strategy",
  "Automation-Ready Brand Infrastructure",
  "Not Sure Yet",
];

// Maps category id -> label used in consultation form.
export const CATEGORY_LABEL_BY_ID = CATEGORIES.reduce((acc, c) => {
  acc[c.id] = c.label;
  return acc;
}, {});
